export const SET_GRAPHQL_TYPE_MAPPER = 'SET_GRAPHQL_TYPE_MAPPER'
export const setGraphqlTypeMapper = (mapper: $TSFixMe) => ({
  type: SET_GRAPHQL_TYPE_MAPPER,
  mapper,
})
